import mySiema from '../vendors/siemaExtends';

export default class IconTabCarousel {
    options: any;
    iconTabBlocks: NodeListOf<HTMLElement>;

    constructor(options?: object) {
        this.options = IconTabCarousel.updateSettings(options);
        this.iconTabBlocks = document.querySelectorAll('.icon-tab-block');
    }

    static updateSettings(userSettings) {
        let defaultSettings = {
            carouselEl: ".siema.is-mobile-tab-carousel",
            slidesWrapperEl: <any>".siema-slides-wrapper",
            arrowsCopy: {
                previous: `<span aria-label="previous image" class="icon icon-angle-left"></span>`,
                next: `<span aria-label="next image" class="icon icon-angle-right"></span>`
            }
        };

        for (const attrname in userSettings) {
            defaultSettings[attrname] = userSettings[attrname];
        }

        defaultSettings.slidesWrapperEl = (<NodeList>document.querySelectorAll(`${defaultSettings.carouselEl} ${defaultSettings.slidesWrapperEl}`));

        return defaultSettings;
    }

    init() {
        if (this.options.slidesWrapperEl.length) {

            Array.prototype.forEach.call(this.options.slidesWrapperEl, function (el) {
                new mySiema({
                    selector: el,
                    duration: 300,
                    easing: 'ease-in-out',
                    perPage: {
                        0: 2,
                      //  600: 2,
                        750: 3
                    },
                    offset: 0.15
                });
            });
        }

        if (this.iconTabBlocks.length > 0) {
            Array.prototype.forEach.call(this.iconTabBlocks, iconTabBlock => {
                const iconTabList = iconTabBlock.querySelectorAll('.icon-tab');
                const tabWindowList = iconTabBlock.querySelectorAll('.content-tab');

                Array.prototype.forEach.call(iconTabList, iconTab => {
                    let tabNumber = iconTab.getAttribute('data-tab-number');

                    iconTab.addEventListener('click', () => {
                        Array.prototype.forEach.call(iconTabList, tab => {
                            tab.classList.add('has-bg-gray-10');
                        });

                        iconTab.classList.remove('has-bg-gray-10');
                        iconTab.classList.add('has-bg-gray-0');

                        Array.prototype.forEach.call(tabWindowList, tabWindow => {
                            let windowNumber = tabWindow.getAttribute('data-window-number');
                            tabWindow.classList.add('is-d-none');

                            if (windowNumber === tabNumber) {
                                tabWindow.classList.remove('is-d-none');
                            }
                        });
                    });

                    if (tabNumber === 1) {
                        iconTab.classList.remove('has-bg-gray-10');
                        iconTab.classList.add('has-bg-gray-0');

                        Array.prototype.forEach.call(tabWindowList, tabWindow => {
                            let windowNumber = tabWindow.getAttribute('data-window-number');

                            if (windowNumber === 1) {
                                tabWindow.classList.remove('is-d-none');
                            }
                        });

                    }
                });
            });

        }
    }
}